import { render, staticRenderFns } from "./VisionField.vue?vue&type=template&id=4f88be40&lang=pug&"
import script from "./VisionField.vue?vue&type=script&lang=js&"
export * from "./VisionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports